<template>
    <div class="star-rating">
        <div class="star-rating__stars">
            <span
                v-for="i in 5"
                :key="i"
                class="star-rating__star"
                :class="{ 'star-rating__star--filled': i <= filledStars }"
            >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 1L10.163 5.279L15 6.006L11.5 9.428L12.326 14.25L8 12.015L3.674 14.25L4.5 9.428L1 6.006L5.837 5.279L8 1Z"
                        :fill="i <= filledStars ? '#faad14' : '#e0e0e0'"
                        stroke="none"
                    />
                </svg>
            </span>
        </div>
        <span v-if="showLabel" class="star-rating__label">{{ $t('analyst_rating') }}</span>
    </div>
</template>

<script >
import { computed } from 'vue-demi';
import { LanguageId, useI18n } from '../../common/useI18n';
const __sfc_main = {};
__sfc_main.props = {
  rating: {
    type: Number,
    default: 0,
    validator: value => value >= 0 && value <= 5
  },
  showLabel: {
    type: Boolean,
    default: true
  },
  languageId: {
    type: Number,
    default: LanguageId.EN
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const $t = useI18n(props.languageId);
  const filledStars = computed(() => Math.round(props.rating));
  return {
    $t,
    filledStars
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.star-rating {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.08rem;

    &__stars {
        display: flex;
        align-items: center;
        gap: 0.04rem;
    }

    &__star {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.32rem;
        height: 0.32rem;

        svg {
            width: 100%;
            height: 100%;
        }
    }

    &__label {
        font-size: 0.2rem;
        font-weight: 400;
        color: #999;
        line-height: 1.4;
        margin-top: 0.1rem;
    }
}
</style>
